/* eslint-disable */
import { Injectable } from '@angular/core';
import * as _ from 'lodash';
import { NgRedux } from '@angular-redux/store';
import { SET_DATA, DELETE_DATA, DELETE_INDEX } from './action.constants.js';
import { ApplicationHooks } from './application.hooks';

@Injectable()
export class ApplicationActions {
  constructor(redux: NgRedux, hooks: ApplicationHooks) {
    this.redux = redux;
    this.hooks = hooks;
  }

  setData(path, value) {
    this.hooks.execute(path, value, this);

    this.redux.dispatch({ type: SET_DATA, path, value });
  }

  deleteData(path) {
    this.redux.dispatch({ type: DELETE_DATA, path });
  }

  deleteArrayIndex(path, index) {
    this.redux.dispatch({ type: DELETE_INDEX, path, index });
  }

  clearData(path) {
    const data = this.getData(path);
    if (data !== null && typeof data === 'object') {
      const keys = Object.keys(data);
      for(let key of keys) {
        this.deleteData(`${path}.${key}`);
      }
    }
  }

  getData(path, defaultValue = null) {
    let currentValue = _.get(this.redux.getState().applicationStore, path);
    // Make sure we get a clone of the state rather than the actual state
    // We want to prevent mutating the state outside of a reducer
    if (currentValue !== null && typeof currentValue === 'object') currentValue = _.merge({}, currentValue);
    return currentValue === undefined || currentValue === null ? defaultValue : currentValue;
  }

  getState() {
    return _.merge({}, this.redux.getState().applicationStore);
  }
}
